<template>
  <component
    :is="tagName"
    role="button"
    :disabled="disabled"
    :class="cls"
    v-bind="$attrs"
    @click="_clickHandler"
  >
    <Loading v-if="loading" size="sm" />
    <slot />
  </component>
</template>
<script>
import Loading from '../Loading'
const prefixCls = 'tt-button'
export default {
  name: 'Button',
  components: { Loading },
  props: {
    theme: 'default' | 'primary' | 'info' | 'error' | 'warning' | 'success',
    size: 'lg' | 'sm' | 'md',
    htmlType: 'button' | 'submit' | 'reset',
    tagName: {
      type: String,
      default: 'button'
    },
    block: Boolean,
    loading: Boolean,
    disabled: Boolean,
    ghost: Boolean
  },
  computed: {
    slot() {
      return this.$slots.default
    },
    cls() {
      return {
        [prefixCls]: true,
        [`${prefixCls}-disabled`]: this.disabled,
        [`${prefixCls}-theme--${this.theme}`]: this.theme,
        [`${prefixCls}-size--${this.size}`]: this.size,
        [`${prefixCls}-ghost`]: this.ghost,
        [`${prefixCls}-block`]: this.block,
        [`${prefixCls}-loading`]: this.loading
      }
    }
  },
  methods: {
    _clickHandler(e) {
      e.preventDefault()
      if (this.loading || this.disabled) return
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="less">
@import '~uikit';
@prefix-cls: 'tt-button';
.button(@color, @fontColor) {
  background-color: @color;
  color: @fontColor;
  &:not(:disabled) {
    &:hover,
    &:focus,
    &:active {
      color: @fontColor;
      background-color: @color;
      opacity: 0.8;
    }
  }
}
.tt-button {
  box-sizing: border-box;
  height: 30px;
  padding: 6px 12px;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  .button(var(--btn-bg), @pure-white);
  &-block {
    display: block;
    width: 100%;
  }
  &-theme--primary {
    .button(var(--active-color), var(--btn-color));
  }
  &-theme-error {
    .button(@error, var(--btn-color));
  }
  &-theme-warning {
    .button(@warning, var(--btn-color));
  }
  &-theme-success {
    .button(@success, var(--btn-color));
  }
  &-theme-info {
    .button(@info, var(--btn-color));
  }
  &-size--lg {
    height: 40px;
  }
  &-size--sm {
    height: 28px;
  }
  &-disabled {
    cursor: default;
    opacity: 0.7;
    color: @pure-white;
    background-color: var(--btn-bg);
  }
  .tt-loading {
    width: 15px;
    height: 15px;
    border-width: 1px;
    border-left-color: var(--btn-color);
  }
}
</style>
